var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g(_vm._b({class:['circle-button flex-center', ("" + _vm.colorPreset), _vm.size]},'button',_vm.$attrs,false),_vm.$listeners),[_c('span',{class:("fas fa-" + _vm.icon)})])}
var staticRenderFns = []

export { render, staticRenderFns }